// removed by extract-text-webpack-plugin
module.exports = {"filter":"_2j5jTK13RK13uN449Lj5kt","filter-container":"_3NS3uWpb1CO6gIl4pWdqfw","loading":"_1c3WBzMdXpMfljgFtZRUen","companies":"_284JPoPjYn8HSRDHk28zM2","contacts-list":"_3yhKMxRETEF3vXTtWlbf8i","load-more-button":"_1wF8tsnano3650UMz6ATPX","error":"_3J8ozq_QXCzrP309IQzv-8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactsList/ContactsList.module.scss
// module id = 743
// module chunks = 0